<template>
  <modal
    name="videoViewer"
    transition="pop-out"
    class="video-view-modal"
    :width="800"
    :height="500"
    v-model="show"
  >
    <div class="position-relative modal-outer-container">
      <div class="modal-header border-bottom">
        <div>
          {{ videoName }}
        </div>
        <button class="btn border-0" @click="closeModal">
          <i class="fas fa-times fa-lg"></i>
        </button>
      </div>
      <div class="body-inner-container">
        <div class="card-body">
          <div class="loading-text" v-if="!videoIsReady">
            <span>Video being loading...</span>
          </div>
          <div>
            <video
              ref="videoPlayer"
              class="video-player vjs-big-play-centered"
              playsinline="true"
              :controlslist="noDownload ? 'nodownload' : ''"
              controls
              @canplay="onPlayerCanplay($event)"
            >
              <source :src="videoLink" type="video/mp4" />
            </video>
          </div>
        </div>
      </div>
    </div>
  </modal>
</template>
<script>
export default {
  name: "video-viewer",
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    videoName: {
      type: String,
      required: true,
    },
    videoLink: {
      type: String,
      required: true,
    },
    noDownload: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      videoIsReady: false,
    };
  },
  computed: {
    show: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    recording: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.videoIsReady = false;
      }
    },
  },
  methods: {
    closeModal() {
      this.$emit("update:modelValue", false);
    },
    onPlayerCanplay() {
      this.videoIsReady = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.video-view-modal {
  .video-player {
    background-color: #000;
    width: 780px;
    height: 420px;
    @media (max-width: 767px) {
      width: 100% !important;
      height: 400px !important;
    }
  }
  .loading-text {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #fff;
    font-size: 1.2rem;
    font-weight: 600;
    z-index: 1000;
    animation: loading 1.5s infinite;
    @keyframes loading {
      0% {
        opacity: 0.5;
      }
      50% {
        opacity: 1;
      }
      100% {
        opacity: 0.5;
      }
    }
  }
  .modal-header {
    color: #000;
    font-weight: 600;
    font-size: 1.2rem;
    > div {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
    @media (max-width: 767px) {
      font-size: 1rem;
    }
  }
}
</style>
